/**
 * Hero-slideren.
 *
 * Vanilla og uden byggetrin: modulet har ingen berøring med render-core, og et Vite-bundle
 * for tres linjer ville kun gøre det sværere at se hvad der kører.
 *
 * ═══ Autoplay er en høflighed ═══
 *
 * Designets egen note. Den kører af sig selv, men:
 *   · holder pause når musen er over ELLER noget i slideren har fokus — ellers flytter
 *     sliden sig under fingeren på en der er ved at trykke,
 *   · starter aldrig for en bruger med `prefers-reduced-motion`,
 *   · stopper permanent så snart nogen selv har navigeret. Har man taget rattet, skal
 *     man ikke kæmpe med det bagefter.
 *
 * Skinnen er scroll-snap, så pilene bare scroller. Positionen aflæses af scrollLeft frem
 * for at blive holdt i en variabel — så kan brugeren swipe, og tælleren følger med uden
 * at de to kan komme ud af trit.
 */
(function () {
  var roots = document.querySelectorAll('[data-sport-hero]')
  if (!roots.length) return

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  Array.prototype.forEach.call(roots, function (root) {
    var rail = root.querySelector('[data-hero-rail]')
    var slides = root.querySelectorAll('[data-hero-slide]')
    var counter = root.querySelector('[data-hero-count]')
    if (!rail || slides.length < 2) return

    var seconds = Number(root.getAttribute('data-autoplay')) || 0
    var timer = null
    var surrendered = false

    function pad(n) { return (n < 10 ? '0' : '') + n }

    function index() {
      // Afrunding frem for gulv: halvvejs igennem en slide ER man på den næste.
      return Math.round(rail.scrollLeft / rail.clientWidth)
    }

    function paint() {
      if (counter) counter.textContent = pad(index() + 1) + ' / ' + pad(slides.length)
    }

    function go(to, smooth) {
      var n = (to + slides.length) % slides.length
      rail.scrollTo({ left: n * rail.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' })
    }

    function stop() { if (timer) { clearInterval(timer); timer = null } }

    function start() {
      if (reduced || surrendered || seconds <= 0 || timer) return
      timer = setInterval(function () { go(index() + 1) }, seconds * 1000)
    }

    function surrender() { surrendered = true; stop() }

    rail.addEventListener('scroll', paint, { passive: true })
    window.addEventListener('resize', paint)

    root.addEventListener('mouseenter', stop)
    root.addEventListener('mouseleave', start)
    root.addEventListener('focusin', stop)
    root.addEventListener('focusout', start)

    var prev = root.querySelector('[data-hero-prev]')
    var next = root.querySelector('[data-hero-next]')
    if (prev) prev.addEventListener('click', function () { surrender(); go(index() - 1) })
    if (next) next.addEventListener('click', function () { surrender(); go(index() + 1) })

    // En swipe tæller også som at have taget rattet.
    rail.addEventListener('pointerdown', surrender)

    paint()
    start()
  })
})()
